import React from 'react';
interface TermsModalProps {
  onClose: () => void;
}
export const TermsModal: React.FC<TermsModalProps> = ({
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-523">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto" data-id="element-524">
        <div className="p-6" data-id="element-525">
          <div className="flex justify-between items-center mb-4" data-id="element-526">
            <h2 className="text-xl font-bold text-gray-800" data-id="element-527">
              Terms of Service
            </h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-528">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-529">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-530" />
              </svg>
            </button>
          </div>
          <div className="prose prose-sm" data-id="element-531">
            <p data-id="element-532">
              By accessing and placing an order with Voices of Freedom, you
              confirm that you are in agreement with and bound by the terms and
              conditions contained in the Terms of Service outlined below.
            </p>
            <h3 data-id="element-533">Intellectual Property Rights</h3>
            <p data-id="element-534">
              All content included on this site, such as text, graphics, logos,
              images, as well as the compilation thereof, and any software used
              on the site, is the property of Voices of Freedom or its suppliers
              and protected by copyright and other laws.
            </p>
            <h3 data-id="element-535">License and Site Access</h3>
            <p data-id="element-536">
              Voices of Freedom grants you a limited license to access and make
              personal use of this site. This license does not include any
              resale or commercial use of this site or its contents; any
              collection and use of any product listings, descriptions, or
              prices; any derivative use of this site or its contents; any
              downloading or copying of account information for the benefit of
              another merchant; or any use of data mining, robots, or similar
              data gathering and extraction tools.
            </p>
            <h3 data-id="element-537">User Account</h3>
            <p data-id="element-538">
              If you use this site, you are responsible for maintaining the
              confidentiality of your account and password and for restricting
              access to your computer, and you agree to accept responsibility
              for all activities that occur under your account or password.
            </p>
            <h3 data-id="element-539">Order Acceptance</h3>
            <p data-id="element-540">
              Voices of Freedom reserves the right to refuse service to anyone
              for any reason at any time. We reserve the right to limit the
              quantity of items purchased per person, per household, or per
              order.
            </p>
            <h3 data-id="element-541">Governing Law</h3>
            <p data-id="element-542">
              These terms and conditions are governed by and construed in
              accordance with the laws of the United States and you irrevocably
              submit to the exclusive jurisdiction of the courts in that
              location.
            </p>
          </div>
        </div>
      </div>
    </div>;
};